"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserLevelSettingsClient = void 0;
const dp_http_client_lib_1 = require("@greatmindsorg/dp-http-client-lib");
const sdk_constants_1 = require("../../constants/sdk.constants");
const serializers_1 = require("../serializers");
class UserLevelSettingsClient {
    static newInstance(options, retryOptions) {
        return new UserLevelSettingsClient(dp_http_client_lib_1.RetryableHttpClient.newInstance(options, retryOptions), new serializers_1.UserLevelSettingsSerializer());
    }
    constructor(client, userLevelSettingsSerializer) {
        this.client = client;
        this.userLevelSettingsSerializer = userLevelSettingsSerializer;
    }
    async upsertUserSettings(userSetting, headers) {
        await this.client.put(`${sdk_constants_1.MANAGEMENT_API_PREFIX}/userSettings`, userSetting, {
            headers,
        });
    }
    async upsertClassStudentSettings(userSetting, headers) {
        await this.client.put(`${sdk_constants_1.MANAGEMENT_API_PREFIX}/classStudentSettings`, userSetting, {
            headers,
        });
    }
    async getOwnUserSettings(headers) {
        const response = await this.client.get(`${sdk_constants_1.MANAGEMENT_API_PREFIX}/userSettings`, {
            headers,
        });
        return this.userLevelSettingsSerializer.serializeOne(response.body.data);
    }
    async getStudentUserSettings(userIds, headers) {
        const response = await this.client.get(`${sdk_constants_1.MANAGEMENT_API_PREFIX}/userSettings.findByStudent`, {
            headers,
            params: { userId: userIds },
        });
        return response.body.data.map((userSetting) => this.userLevelSettingsSerializer.serializeOne(userSetting));
    }
}
exports.UserLevelSettingsClient = UserLevelSettingsClient;
//# sourceMappingURL=user-level-settings.client.js.map